'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BibBrief = require('./components/BibBrief.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BibBrief).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-bib-brief/lib/index.js
// module id = 46
// module chunks = 1